import styled from 'styled-components'

export const QualitySectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
